import { TFunction } from 'react-i18next';
import { OrderStatus, OrderType, PaymentMethod, PaymentStatus } from '@/models/order.model';

export const getStepTypeOptions = (t: TFunction) =>
  Object.values(OrderType).map((value) => ({
    value,
    label: t(`step_type_${value.toLowerCase()}`),
  }));

export const getStatusOptions = (t: TFunction) =>
  Object.values(OrderStatus).map((value) => ({
    value,
    label: t(`status_${value.toLowerCase()}`),
  }));

export const getPaymentMethodOptions = (t: TFunction) =>
  Object.values(PaymentMethod).map((value) => ({
    value,
    label: t(`payment_method_${value.toLowerCase()}`),
  }));

export const getPaymentStatusOptions = (t: TFunction) =>
  Object.values(PaymentStatus).map((value) => ({
    value,
    label: t(`payment_status_${value.toLowerCase()}`),
  }));

export const getOrderStatusOptions = (t: TFunction, canComplete = false) => [
  {
    value: OrderStatus.NEW,
    label: t(`status_${OrderStatus.NEW.toLowerCase()}`),
    disabled: true,
  },
  {
    value: OrderStatus.CANCELED,
    label: t(`status_${OrderStatus.CANCELED.toLowerCase()}`),
  },
  {
    value: OrderStatus.IN_PROGRESS,
    label: t(`status_${OrderStatus.IN_PROGRESS.toLowerCase()}`),
  },
  {
    value: OrderStatus.COMPLETED,
    label: t(`status_${OrderStatus.COMPLETED.toLowerCase()}`),
    disabled: !canComplete,
  },
];
